module.exports = __webpack_public_path__ + "a0e2200d8ed70e026d3b16a1d42750da.png";